/**
 * Fixes the Mac URL by adding the correct architecture to the URL.
 * @param url The URL to fix.
 * @returns The fixed URL.
 */
export default function fixMacUrl(url: string) {
  const baseUrl = new URL(url);
  baseUrl.pathname = `${baseUrl.pathname}/zip/${process.arch}`;
  return baseUrl.href;
}
